import { render, staticRenderFns } from "./ShoppingTable.vue?vue&type=template&id=67edded2&"
import script from "./ShoppingTable.vue?vue&type=script&lang=js&"
export * from "./ShoppingTable.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports